export default {
      id: "icon-location-usage",
      viewBox: "0 0 9.8 14.22",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-location",
      toString: function () {
        return this.url;
      }
    }